
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Nama Merchant / Aggregator', value: 'merchant_name'},
  { text: 'Nama Aggregator', value: 'aggregator_name'},
  { text: 'MID', value: 'mid'},
  { text: 'Email', value: 'email', width: '300'},
  { text: 'Subject', value: 'subject'},
  { text: 'Broadcast Date', value: 'broadcast_date'},
  { text: 'Status', value: 'status'},
  { text: 'Resend Date', value: 'resend_date'},
  { text: 'Resend Counter', value: 'resend_counter'},
  { text: 'Action', value: 'action', width: '100' }
]);

export const dataBroadcastLogStatus = [
  { value: 'success', text: 'success' },
  { value: 'failed', text: 'failed' },
];

export const search = {
  merchant_name: '',
  aggregator_name: '',
  mid: '',
  email: '',
  subject: '',
  broadcast_date: null,
  status: '',
  resend_date: null,
  resend_counter: '',
};

